export default {
  zh: {
    emailTemplates: "邮箱模板",
    hideDepartments: "隐藏部门",
    editFolders: "編輯我的文档",
    addTemplate: "添加新模板",
    newEmailTemplate: "新邮件模板",
    templates: "模板",
    permissionSetting: "权限设置",
    newFolder: "新建文档",
    editFolderTitle: "编辑文档",
    dragFolder: "拖拽文档改变顺序",

    templateName: "模板标题",

    templateModifiedDate: "更改日期",

    templateDescription: "详情",
    permissionToGetAccess: "获取权限",
    folder: "文件夹",
    emailTemplatesName: "邮件模板名字",
    emailTemplateApiName: "邮件模板接口名字",
    newTemplateDescription: "详情",
    fieldInfo: "领域信息",
    selectField: "选择领域",
    fieldValue: "领域值",
    importHtmlTemplate: "导入HTML模板",
    importTemplateHintLine1: "上传的 HTML 模板文件必须是 ZIP 或 RAR 压缩包。",
    importTemplateHintLine2: "在压缩包内，必须包含一个名为 index.html 的文件。",
    preview: "预览",
    newEmail: "新邮件",
    send: "发送",
    discard: "取消",
    to: "收件人:",
    cc: "抄送:",
    bcc: "密送:",
    subject: "主题:",
    selectTemplate: "选择模板",
    cloudAttachment: "云附件",
    localAttachment: "本地附件",
    attachment: "附件",
    by: "共享者：",
    sharedBy: "共享",
    permissionTitle: "访问权限",
    addNewUser: "添加用户权限",

    attachFiles: "添加附件",
    chooseCloudAttachment: "选择云附件",
    attachLocalFiles: "上传本地文件",
    fileName: "文件名",
    chooseFile: "选择文件",
    chooseFolder: "选择文件夹",
    category: "分类",
    myFolders: "我的文件夹",
    noAuthMessage: "检查授权",
    emailSendMessage: "邮件已发送",
    emailToEmptyError: "收件人不能是空的",
    emailToFormatError: "收件人邮箱格式不正确",
    emailCcFormatError: "抄送邮箱格式不正确",
    emailBccFormatError: "密抄邮箱格式不正确",
    emailSubjectEmptyError: "邮件主题不能为空",
    doubleClickHint: "双击以选择模板",
    duplicatedFolderName: "文件夹名称不能重复",
    emptyFolderName: "文件夹名称不能为空",
    needAuthMessage: "请点击下面的链接去授权您的邮箱",
    selectCategoryHint: "请注意，更换模板类型将会清空模板内容",
    emailCampaignsSeparator:
      "............................................................................................",
    emailCampaign: "活动邮件",
    campaignName: "名称",
    subscriberList: "订阅者列表",

    startDate: "开始日期",
    endDate: "截止日期",
    status: "状态",
    campaignDescription: "详情",
    newCampaign: "新活动",
    subscriberLists: "订阅者列表",
    unsubscriberList: "退订者名单",
    newEmailCampaign: "新活动邮件",
    stepOne: "第一步：信息",
    emailTemplate: "邮件模板",
    stepTwo: "第二步: 时间安排",
    schedulesDescription: "( 邮件活动开始日期和截止日期如下 )",
    ongingCampaign: "持续的活动",

    commonUseSeparator:
      "................................................................................................",
    name: "名称",
    type: "种类",
    createdDate: "创建日期",
    createdBy: "创建者",
    save: "保存",
    cancel: "取消",
    description: "详情"
  },
  en: {
    emailTemplates: "Email Templates",
    hideDepartments: "Hide Departments",
    editFolders: "Edit My Folders",
    addTemplate: "Add New Template",
    newEmailTemplate: "New Email Template",
    templates: "Templates",
    permissionSetting: "Permission Setting",
    newFolder: "New Folder",
    editFolderTitle: "Edit Folder",
    dragFolder: "Drag the folder to change the order.",

    templateName: "Template Name",

    templateModifiedDate: "Modified Date",

    templateDescription: "Description",
    permissionToGetAccess: "Permission to Get Access",
    folder: "folder",
    emailTemplatesName: "Email Template Name",
    emailTemplateApiName: "Email Template API Name",
    newTemplateDescription: "Description",
    fieldInfo: "Field Information",
    selectField: "Select Field",
    fieldValue: "Field Value",
    importHtmlTemplate: "Import HTML Template",
    importTemplateHintLine1: "The uploaded HTML Template file must be a ZIP or RAR archive.",
    importTemplateHintLine2: "Inside the HTML compressed archive, there must be a file named index.html.",
    preview: "Preview",

    newEmail: "New Email",
    send: "Send",
    discard: "Discard",
    to: "To:",
    cc: "Cc:",
    bcc: "Bcc:",
    subject: "Subject:",
    selectTemplate: "Select Template",
    cloudAttachment: "Cloud Attachment",
    localAttachment: "Local Attachment",
    attachment: "Attachment",
    by: "By: ",
    sharedBy: "Shared By",
    permissionTitle: "Permission to Access",
    addNewUser: "Add New User",

    attachFiles: "Attach Files",
    chooseCloudAttachment: "Choose Cloud Attachment",
    attachLocalFiles: "Attach File from Local",
    fileName: "File Name",
    chooseFile: "Choose File",
    chooseFolder: "Choose Folder",
    category: "Category",
    myFolders: "My Folders",
    noAuthMessage: "Check Auth",
    emailSendMessage: "Email sent successfully",
    emailToEmptyError: "email receiver cannot be empty",
    emailToFormatError: "email receiver must be email",
    emailCcFormatError: "cc target must be email",
    emailBccFormatError: "bcc target must be email",
    emailSubjectEmptyError: "subject cannot be empty",
    doubleClickHint: "Double click to select template",
    duplicatedFolderName: "Folder name cannot be duplicated",
    emptyFolderName: "Folder name cannot be empty",
    needAuthMessage: "Please go to the link below to authenticate your email",
    selectCategoryHint:
      "Please be aware the content of this template will be empty if the category is changed",
    emailCampaignsSeparator:
      "............................................................................................",
    emailCampaign: "Email Campaigns",
    campaignName: "Campaign Name",
    subscriberList: "Subscriber List",

    startDate: "Start Date",
    endDate: "End Date",
    status: "Status",
    campaignDescription: "Description",
    newCampaign: "New Campaign",
    subscriberLists: "Subscriber Lists",
    unsubscriberList: "Unsubscriber List",

    newEmailCampaign: "New Email Campaigns",
    stepOne: "Step 1: Information",
    emailTemplate: "Email Template",
    stepTwo: "Step 2: Schedules",
    schedulesDescription:
      "( Email campaign start at the start date, and end at the end date. )",
    ongingCampaign: "Ongoing Campaign",

    commonUseSeparator:
      "................................................................................................",
    name: "Name",
    type: "Type",
    createdDate: "Created Date",
    createdBy: "Created By",
    save: "Save",
    cancel: "Cancel",
    description: "Description"
  }
};



// WEBPACK FOOTER //
// ./src/views/email/i18n.js